import {isEmpty, isArray, isObject} from "./is";
import {store} from "../store/store";
import {alertQuestionService} from "../services/alertQuestionService";
import {ConstantEventEmitter} from "../data/ConstantEventEmitter";
import Emitter from "../EventEmitter/EventEmitter";
import isMatch from 'date-fns/isMatch';
import {GlobalConstants} from "../data/GlobalConstants";
import {loaderService} from "../services/loaderService";
import { Colors } from "src/assets/colors/Colors";

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        loaderService.clear();

        if (!response.ok) {

            if (response.status === 401) {
                store.dispatch({ type: 'setStateFinishAuth', auth: {} });
            }

            const error = (data && data.msg) || response.statusText;

            return Promise.reject(error);
        }

        return data;

    });
}


export function getLabelRoute(pathName, routes) {

  if(isEmpty(pathName) || isEmpty(routes) || !isArray(routes)){
     return "No existe la ruta";
  }

  let ruta = routes.find(route => route.path === pathName);

  return ruta?.name || "No existe la ruta";

}


export const nombrePropio = (texto) => {

  if(isEmpty(texto)){
    return "XXXX-XXXX-XXXX"
  }

  let cadena = texto.toLowerCase().split(' ');

  for (var i = 0; i < cadena.length; i++) {
    cadena[i] = cadena[i].charAt(0).toUpperCase() + cadena[i].substring(1);
  }

  texto = cadena.join(' ');

  return texto;

}


export const firstLetterUpper = (texto , breadcumbs) => {
  if (breadcumbs) {
    return texto.replace(/[-_]/gi," ").replace(/[.*+\/-?^${}()|[\]\\]/g,"").replace(/\b\w/g, l => l.toUpperCase());
  } else {
    return texto.replace(/\b\w/g, l => l.toUpperCase());
  }
}

let colorIndex = 0;
export function getRandomColor() {
  if(colorIndex > 4){
    colorIndex = 0;
  }
  let colors = ['#F18892', '#AECD69', '#ED8134', '#6CC3CD', '#B38ABD'];
  let colorSeleccionado = colors[colorIndex];
  colorIndex++;
  return colorSeleccionado;
}


export function convertToString(value) {

  if(isEmpty(value)){
    return "";
  }

  if(typeof value === "string"){
    return value.toString();
  }

  if(typeof value === "number"){
    return value.toString();
  }

  return value.toString();

}


export function getFechaToCalendar(fecha) {


  if(isEmpty(fecha)){
    return new Date();
  }

    if (typeof fecha === "string") {


      let test = new Date(`${fecha} 00:00:00`);

      if(!isDateValid(dateToStringFormat(test))){
        fecha = new Date();
      }
      else{
        if (isMatch(fecha, 'yyyy-MM-dd')) {
          const newDate = new Date(`${fecha} 00:00:00`);
          if (isNaN(newDate.getTime())) {
            fecha = new Date();
          }
          else{
            fecha = new Date(`${fecha} 00:00:00`);
          }
        } else {
          fecha = new Date();
        }
      }

    }


  return fecha;

}


export function isDateValid(fecha) {

  let booleanState = false;

  if(typeof fecha === "string"){
    if(isMatch(fecha, 'yyyy-MM-dd')){
      const newDate = new Date(`${fecha} 00:00:00`);
      if(isNaN(newDate.getTime())){
        booleanState = false;
      }
      else{
        booleanState = true;
      }
    }
  }
  else if(fecha instanceof Date){
    booleanState = true;
  }
  return booleanState;
}


export function getFechaTimeToCalendar(fechaTime) {

  if(isEmpty(fechaTime)){
    return new Date();
  }

  if(typeof fechaTime === "string"){
    if(isMatch(fechaTime, 'yyyy-MM-dd HH:mm:ss')){
      return new Date(fechaTime);
    }
  }

  if (fechaTime instanceof Date) {
    return fechaTime;
  }

  return new Date();

}


export function getFechaToCalendarRange(fechaIni, fechaFin) {

  if(isEmpty(fechaIni) || isEmpty(fechaFin)){
    return [new Date(), new Date()];
  }

  if(typeof fechaIni === "string" && typeof fechaFin === "string"){
    if(isMatch(fechaIni, 'yyyy-MM-dd') && isMatch(fechaFin, 'yyyy-MM-dd')){
      return [new Date(`${fechaIni} 00:00:00`), new Date(`${fechaFin} 00:00:00`)];
    }
  }

  if (fechaIni instanceof Date && fechaFin instanceof Date) {
    return [fechaIni, fechaFin];
  }

  return [new Date(), new Date()];

}


export function getAcronymName(name) {

  if(isEmpty(name)){
    name = "NN";
  }

  let initials = name.split(' ');

  if(initials.length > 1) {
    initials = initials.shift().charAt(0) + initials.pop().charAt(0);
  } else {
    initials = name.substring(0, 2);
  }

  return initials.toUpperCase();

}


export function changeActionsTable({type, params, id}) {

  switch (type) {

    case ConstantEventEmitter.keyActionsTableEdit:
      Emitter.emit(ConstantEventEmitter.eventCrudModalTable, {params, type: ConstantEventEmitter.keyActionsTableEdit})
      break;

    case ConstantEventEmitter.keyActionsTableView:
      Emitter.emit(ConstantEventEmitter.eventCrudModalTable, {params, type: ConstantEventEmitter.keyActionsTableView})
      break;

    case ConstantEventEmitter.keyActionsTableDelete:
      alertQuestionService.showAlert({title: `Eliminar registro #${id}`, question: `¿Está seguro de eliminar el registro?`,
        message: `Recuerda que al eliminar el registro no podras recuperarlo...`,
        actionBtnAceptar: () => Emitter.emit(ConstantEventEmitter.eventDeleteTable, {
          params,
          type: ConstantEventEmitter.keyActionsTableDelete
        }),
        actionBtnCancelar: () => alertQuestionService.clear(),
        type: GlobalConstants.alertError
  });
      break;

    default:
      return false;

  }

}


export function validObjectKeys(obj , objReplace = {}) {

  if(isEmpty(obj)){
    return objReplace;
  }

  if(!isObject(obj)){
    return objReplace;
  }

  if(Object.keys(obj).length > 0){
    return obj;
  }

  return objReplace;
}


export function validArray(arr) {

  if(isEmpty(arr)){
    return [];
  }

  if(!isArray(arr)){
    return [];
  }

  if(arr.length > 0){
    return arr;
  }

  return [];
}


export const formatAddress = (valor, nomenclaturas) => {

  try{

    let arrNomenclarutas = nomenclaturas.map(x => ({sinonimos: x.sinonimos, nomenclatura: x.id}));
    let addrSplit = validArray(valor.split(","));
    let addr = addrSplit[0].toUpperCase();
    let addrSinCaracteresEspeciales = addr.replace(/[^a-zA-Z0-9]/g, ' ')
    let addrSinCaracteresSplit = addrSinCaracteresEspeciales.split(" ");
    let addrClean = cleanArray(addrSinCaracteresSplit.slice());
    let addStrDian = "";

    for(let itemStr of addrClean){

      if(isNaN(itemStr)){

        let itemStrSeparandoNumerosyLetras = itemStr.match(/[a-z]+|[^a-z]+/gi).join(" ").replace(/\s+/g, " ");

        let itemStrSeparadoSplit = itemStrSeparandoNumerosyLetras.split(" ");

        let i = 0;

        for(let itemStrSeparadoSplitVal of itemStrSeparadoSplit){

          if(isNaN(itemStrSeparadoSplitVal)){

            if(itemStrSeparadoSplitVal.length > 1){

              let obj = arrNomenclarutas.filter(x => x.sinonimos.includes(itemStrSeparadoSplitVal));

              if(!isEmpty(obj[0])){
                itemStrSeparadoSplit[i] = obj[0].nomenclatura;
              }

            }

          }

          i++;

        }

        let itemStrSeparadoConNomenclatura = itemStrSeparadoSplit.join(" ");

        addStrDian += itemStrSeparadoConNomenclatura + " ";
      }
      else{
        addStrDian += itemStr + " ";
      }

    }

    return addStrDian;

  }
  catch (e) {

  }

  return valor;
}

export function cleanArray( actual ){
  var newArray = new Array();
  for( var i = 0, j = actual.length; i < j; i++ ){
    if ( actual[ i ] ){
      newArray.push( actual[ i ] );
    }
  }
  return newArray;
}

export const formatAddressToArray = (txDireccion, nomenclaturas) => {

  try{

    if(isArray(txDireccion)){
      return txDireccion;
    }

    let arrDireccion = [];
    let arrDir = txDireccion.split(" ");

    for(let item of arrDir){

      let obj = nomenclaturas.find(x => convertToString(x?.id) === convertToString(item));

      if(obj){
        arrDireccion.push(obj);
      }
      else{
        arrDireccion.push(item);
      }

    }

    return arrDireccion;

  }
  catch (e){

  }

  return [];

}


export const calcularDigitoVerificacion = (myNit) => {
  let vpri,
    x,
    y,
    z;


  myNit = myNit.replace ( /\s/g, "" ) ;
  myNit = myNit.replace ( /,/g,  "" ) ;
  myNit = myNit.replace ( /\./g, "" ) ;
  myNit = myNit.replace ( /-/g,  "" ) ;


  if  ( isNaN ( myNit ) )  {
    console.log ("El nit/cédula '" + myNit + "' no es válido(a).") ;
    return "" ;
  };


  vpri = new Array(16) ;
  z = myNit.length ;

  vpri[1]  =  3 ;
  vpri[2]  =  7 ;
  vpri[3]  = 13 ;
  vpri[4]  = 17 ;
  vpri[5]  = 19 ;
  vpri[6]  = 23 ;
  vpri[7]  = 29 ;
  vpri[8]  = 37 ;
  vpri[9]  = 41 ;
  vpri[10] = 43 ;
  vpri[11] = 47 ;
  vpri[12] = 53 ;
  vpri[13] = 59 ;
  vpri[14] = 67 ;
  vpri[15] = 71 ;

  x = 0 ;
  y = 0 ;
  for  ( var i = 0; i < z; i++ )  {
    y = ( myNit.substr (i, 1 ) ) ;

    x += ( y * vpri [z-i] ) ;
  }

  y = x % 11 ;

  return ( y > 1 ) ? 11 - y : y ;
}


export const getDigitoVerificacion = (nit) => {
  if(nit){
    return calcularDigitoVerificacion(nit);
  }

  return '';
}


export const validarEspaciosEnBlanco = (value) => {

  if(isEmpty(value)){
    return "";
  }

  value = value.split(' ').filter(n => n).join(' ')
  return value;
}


export function dateToStringFormat(date) {

  if(isEmpty(date)){
    date = new Date();
  }

  let dia = date.getDate();
  let mes = (date.getMonth()+1);
  let anno = date.getFullYear();

  if(Number(dia) <= 9){
    dia = `0${dia}`;
  }
  if(Number(mes) <= 9){
    mes = `0${mes}`;
  }


  return anno  + "-" + mes + "-" + dia;
}


export function formatDay(dia) {

  switch (dia) {

    case 0:
      return "LU";

    case 1:
      return "MA";

    case 2:
      return "MI";

    case 3:
      return "JU";

    case 4:
      return "VI";

    case 5:
      return "SA";

    case 6:
      return "DO";

    default:
      return dia;

  }

}


export function getDate(params) {
  switch (params) {

    case 'TODAY':
      var fecha = new Date();
      var mes = fecha.getMonth()+1;
      var dia = fecha.getDate();
      var ano = fecha.getFullYear();
      if(dia<10)
        dia='0'+dia;
      if(mes<10)
        mes='0'+mes
      return ano+"-"+mes+"-"+dia;

  }
}


export function getDateTime(params = "TODAY", marcaTiempoImg = false) {
  switch (params) {

    case 'TODAY':
      var fecha = new Date();
      var mes = fecha.getMonth()+1;
      var dia = fecha.getDate();
      var ano = fecha.getFullYear();
      if(dia<10)
        dia='0'+dia;
      if(mes<10)
        mes='0'+mes

      var hora = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();

      return marcaTiempoImg ? ano+"_"+mes+"_"+dia+"_"+hora : ano+"-"+mes+"-"+dia+" "+hora;

  }
}


export function getDiasVisitaEntregaVector(dias, ord) {

  if(isEmpty(dias) || isEmpty(ord)){
    return {
      dias: [-1,-1,-1,-1,-1,-1,-1],
      orden: [-1,-1,-1,-1,-1,-1,-1]
    };
  }

  if(isArray(dias) || isArray(ord)){
    return {
      dias,
      orden: ord
    }
  }

  let splitDias = dias.split(";");
  let splitOrd = ord.split(";");
  let viDias = [-1,-1,-1,-1,-1,-1,-1];
  let viOrden = [-1,-1,-1,-1,-1,-1,-1];
  if(splitDias.length > 0 && splitOrd.length > 0){
    if(splitDias.length === splitOrd.length){
      let count = 0;
      for(let item of splitDias){
        if(item === "LU"){
          viDias[0] = 1;
          viOrden[0] = splitOrd[count];
        }
        else if(item === "MA"){
          viDias[1] = 1;
          viOrden[1] = splitOrd[count];
        }
        else if(item === "MI"){
          viDias[2] = 1;
          viOrden[2] = splitOrd[count];
        }
        else if(item === "JU"){
          viDias[3] = 1;
          viOrden[3] = splitOrd[count];
        }
        else if(item === "VI"){
          viDias[4] = 1;
          viOrden[4] = splitOrd[count];
        }
        else if(item === "SA"){
          viDias[5] = 1;
          viOrden[5] = splitOrd[count];
        }
        else if(item === "DO"){
          viDias[6] = 1;
          viOrden[6] = splitOrd[count];
        }
        count++;
      }
      return {
        dias: viDias,
        orden: viOrden
      };
    }
  }

  return {
    dias: [-1,-1,-1,-1,-1,-1,-1],
    orden: [-1,-1,-1,-1,-1,-1,-1]
  };

}


export const validateDiasEntregaVisita = (arrDias) => {

  if(!isArray(arrDias)){
    return null;
  }

  let count = 0;
  for(let item of arrDias){
    if(Number(item) === -1){
      count++;
    }
  }

  if(count === 7){
    return null;
  }
  else{
    return count;
  }

}

export const sortById = (a, b) => {

    if (Number(a?.id) > Number(b?.id)) {
      return 1;
    }
    if (Number(a?.id) < Number(b?.id)) {
      return -1;
    }

    return 0;
}


export function currencyFormatter(params) {
  return '$' + formatNumber(params.value);
}

export function prcFormatter(params) {
  if(isEmpty(params.value)){
    return '';
  }
  return params.value + '%';
}

export function formatNumberWithThousandsSeparator(params) {
  // Asegurarse de que el valor de entrada sea un número
  const num = Number(params.value);
  // Verificar si el número es válido
  if (isNaN(num)) {
    return 'NaN';
  }
  // Utilizar toLocaleString para agregar puntos en miles sin decimales
  return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export function formatNumber(number) {
  return Math.floor(number)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function getItemsState(list, returnStateOn, key) {

    if(isEmpty(list) || !isArray(list)){
        return 0;
    }

    let count = 0;

    for(let item of list){
      if(returnStateOn) {
        if (item[key] === 1 || item[key] === "1" || item[key] === true || item[key] === "true") {
          count++;
        }
      }
      else{
        if (item[key] === 0 || item[key] === "0" || item[key] === false || item[key] === "false") {
          count++;
        }
      }
    }


    return count;

}

export const showLoading = ({label = "Cargando..."}) => {
  loaderService.showLoader({label})
}

export const generateGenericNameImage = (file, identificador = "") => {

  let marcaTiempo = getDateTime('TODAY', true);
  let randomnumber = Math.floor(Math.random() * 50);
  let usrSession = store.getState().auth?.idUsuario;
  let typeImg = file.type;
  let format = "JPG";
  if(typeImg === "image/png"){
    format = "PNG";
  }

  return "IMG_" + identificador + "_" + "TEMP_" + marcaTiempo + "_" + randomnumber + "_" + usrSession + "_" + "AMOVIL" + "." + format;

}

export const clearFormatImage = (file) => {

  if(isEmpty(file)){
    return file;
  }

  file.replace(".PNG").replace(".JPG");
}

export const validateZonaEspejo = (value) => {
  if(value?.length > 4) return false
  else return true
}

//Auto ajustar el tamaño de una tabla
export const autoSizeColumns = ( params, skipHeader = false) => {
  const allColumnIds = [];
  params.columnApi.getAllColumns().forEach((column) => {
    allColumnIds.push(column.getId());
  });
  params.columnApi.autoSizeColumns(allColumnIds, skipHeader);
}

export const getColorCellValid = (params) => {
  if(params.node.data.error){
    return { 'background-color': Colors.COLOR_CELL_ERROR}
  }else{
      return { 'background-color': Colors.COLOR_CELL_SUCCESS}
  }
}


export const validarFecha = (fecha) => {
  let regEx = /^\d{4}-\d{2}-\d{2}$/
  if(!regEx.test(fecha)) return false
  let d = new Date(fecha);
  if(Number.isNaN(d.getTime())) return false

  return d.toISOString().slice(0,10) === fecha ? true : false
}

/**
 * @param {string} url
 * @returns {string|null}
 * @example
 * getUrlYoutube('https://www.youtube.com/watch?v=9bZkp7q19f0');
 * '9bZkp7q19f0'
 * @description Obtiene el id de un video de youtube
 */
export const getUrlYoutube = (url) => {
    const videoid = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);

    return videoid != null ? videoid[1] : null;
}

/**
 * @param {string} url
 * @returns {string}
 * @example
 * getImageDefaultVideo('https://www.youtube.com/watch?v=9bZkp7q19f0');
 * 'https://img.youtube.com/vi/9bZkp7q19f0/hqdefault.jpg'
 * @description Obtiene la imagen por defecto de un video de youtube
 * */
export const getImageDefaultVideo = (url) => {
    return `https://img.youtube.com/vi/${url.includes("http") ? getUrlYoutube(url) : url}/hqdefault.jpg`
}

/**
 * @param {string} string
 * @param {number} length
 * @returns {string}
 * @example
 * sliceString('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl', 20)
 * 'Lorem ipsum dolor si...'
 * @description Corta un string y le agrega puntos suspensivos
 * */
export const sliceString = (string, length) => {
    if(string.length > length){
        return string.slice(0, length) + '...'
    }

    return string
}

/**
 * @param {canvas} canvas
 * @returns {Promise}
 * @description Convierte un canvas a blob
 */
export const toBlob = (canvas) => {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if(blob) resolve(blob)
            else reject("Error al convertir a blob")
        })
    })
}

/**
 * @returns {string}
 * @description Obtiene la fecha actual en formato YYYYMMDD_hhmmss sin espacios, con el fin de estandarizar el guardado de imágenes en el servidor
 * */
export const getCurrentTime = () => {
    const fullDate = new Date()

    const date = fullDate
        .toISOString()
        .split("T")[0]
        .replaceAll("-", "")

    const time = fullDate
        .toLocaleTimeString()
        .replaceAll(":", "")
        .split(" ")[0]


    return `${date}_${time}`
}

export const autoSize = ( params ) => {
    const allColumns = [];

    params.columnApi.getAllColumns().map( column => allColumns.push(column.colId))
    params.columnApi.autoSizeColumns(allColumns, false);
}
